import { Loader } from '../../../../common'

const LoaderPage = () => {
  return <Loader />
}

export default LoaderPage